import { render, staticRenderFns } from "./CadastreSideMenu.vue?vue&type=template&id=7821c42e&scoped=true"
import script from "./CadastreSideMenu.vue?vue&type=script&lang=js"
export * from "./CadastreSideMenu.vue?vue&type=script&lang=js"
import style0 from "./CadastreSideMenu.vue?vue&type=style&index=0&id=7821c42e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7821c42e",
  null
  
)

export default component.exports